import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import { api_gateway } from '../../../conexoes/api'
import '../../../css/painelCadastros/cadCliente/pavCliente.css'
import {
  desabilitarAcoes,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem,
  revelarCadastroClienteCarregar,
  revelarCadastroClienteExcluir
} from '../../../redux/actions/index'
import decrypt from '../../../utils/decryptJWT'
import { isPortal } from '../../../utils/nivelCliente'
import { RenderMensagemAtencao } from '../../componentesModais/mensagens/mensagemAtencao'
import { RenderMensagemErro } from '../../componentesModais/mensagens/mensagemErro'
import { RenderMensagemSucesso } from '../../componentesModais/mensagens/mensagemSucesso'
import DetalhamentoCliente from '../../painelCadastros/cadCliente/detalhamentoClienteN2/detalhamentoCliente'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'
import Table from '../../Table/index.jsx'

import ImportarClientesUsuarios from './acoes/ImportarClientesUsuarios.js'
import CadastroCliente from './cadastro/cadastro'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
const valorLimite = 50

const mensagemErro = 'Ocorreu um erro ao executar esta ação'

function LabelTabela({ children }) {
  return <p className="fonte-cor-1 label-tabela-1">{children}</p>
}

const TableprimaryKey = 'cd_pav_cliente'

function Clientes(props) {
  const isTelaMeusClientes = () =>
    !!window.location.href.includes('veye/portal/cliente')
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const clientePortal = isPortal()
  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [mensagemSucesso, setMensagemSucesso] = useState('')

  const [itensSelecionados, setItensSelecionados] = useState()

  const despacho = useDispatch()
  const conteudoBusca = useSelector(
    (state) => state.manejadorState.conteudoBusca
  )
  const limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  const realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  const filtros = useSelector((state) => state.filtrosState.filtros)

  const realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  const NovoCliente = useSelector(
    (state) => state.cadastrosState.revelarClienteNovo
  )
  const EditarCliente = useSelector(
    (state) => state.cadastrosState.revelarClienteEditar
  )
  const ExcluirCliente = useSelector(
    (state) => state.cadastrosState.revelarClienteExcluir
  )
  const carregarCliente = useSelector(
    (state) => state.cadastrosState.revelarCadastroClienteCarregar
  )
  let revelarImportarClientesUsuarios = useSelector(
    (state) => state.manejadorState.revelarImportarClientesUsuarios
  )
  let separadorLinha = useSelector(
    (state) => state.manejadorState.separadorLinha
  )

  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )

  const [tipoCliente, setTipoCliente] = useState([])
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)
  const [spinAtivo, setSpinAtivo] = useState(true)

  let itensVar = []

  function isTelaPortalCliente() {
    // Meus Clientes
    let url = window.location.href
    return url.includes('veye/portal/cliente')
  }

  useEffect(() => {
    api_gateway.get('/m1/consultar/cliente_tipo').then((response) => {
      setTipoCliente(transformarObjeto(response.data.dados))
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(1428) // painelCadastroCliente
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    async function handlerCarregarCliente() {
      if (carregarCliente) {
        despacho(revelarCadastroClienteCarregar(false))
        const request =
          '/m1/servicos/alterar_token?login=' +
          decrypt('login') +
          '&email=' +
          decrypt('email') +
          '&codigo=' +
          decrypt('codigo') +
          '&codigoCliente=' +
          itensSelecionados.cd_pav_cliente +
          '&codigoClienteErpAntigo=' +
          itensSelecionados.n0_codigo_cliente +
          '&codigoClienteTexto=' +
          itensSelecionados.n0_codigo_cliente +
          '&nomeDeUsuario=' +
          decrypt('nomeDeUsuario') +
          '&perfil=' +
          decrypt('perfil') +
          '&cdSmsContaUsuario=' +
          decrypt('cdSmsContaUsuario') +
          '&id=' +
          decrypt('id') +
          '&fatContas=' +
          decrypt('fatContas') +
          '&clienteNivel=' +
          itensSelecionados.n0_nivel +
          '&tipoPerfil=' +
          decrypt('tipoPerfil') +
          '&clientePrimario=' +
          decrypt('clientePrimario')
        await api_gateway
          .get(request)
          .then(function (response) {
            if (response.data.status == 200) {
              localStorage.setItem('@veye-Token', response.data.dados.token)

              setMensagemSucesso(
                'O cliente ' +
                  itensSelecionados.ds_nome_fantasia +
                  ' foi carregado com sucesso '
              )
              setRevelarMensagemSucesso(true)
            } else {
              setRevelarMensagemErro(true)
            }
          })
          .catch(() => {
            setRevelarMensagemErro(true)
          })
      }
      if (ExcluirCliente) {
        despacho(revelarCadastroClienteExcluir(false))

        setRevelarMensagemAtencao(true)
      }
    }
    handlerCarregarCliente()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carregarCliente, ExcluirCliente])

  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!props.filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
      despacho(revelarBarraFiltragem(false))
      despacho(limpadorFiltros(false))
    }
    despacho(limpadorFiltros(true))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let data

    setSpinAtivo(true)
    despacho(mudarManejador('cadastroCliente'))

    async function carregarTabela() {
      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          if (isTelaPortalCliente()) {
            data = await api_gateway.get(
              'm1/consultar/cliente?buscar=' +
                conteudoBusca +
                '&cd_pav_cliente_not=true&telaClientePortal=true&separadorLinha=' +
                separadorLinha
            )
          } else {
            data = await api_gateway.get(
              '/m1/consultar/cliente?paginaAtual=' +
                contador +
                '&carregarLimit=' +
                valorLimite +
                '&buscar=' +
                conteudoBusca +
                '&cd_pav_cliente_not=true&separadorLinha=' +
                separadorLinha
            )
          }
          inserirData(data.data.dados)
        }
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paginaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros,
          cd_pav_cliente_not: true
        }
        if (controladorPagina <= paginaAtual) {
          data = await api_gateway.post('/m1/filtrar/cliente', dados)
          inserirData(data.data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          if (isTelaPortalCliente()) {
            data = await api_gateway.get(
              'm1/consultar/cliente?paginaAtual=' +
                contador +
                '&carregarLimit=' +
                valorLimite +
                '&buscar=&cd_pav_cliente_not=true&telaClientePortal=true'
            )
          } else {
            data = await api_gateway.get(
              '/m1/consultar/cliente?paginaAtual=' +
                contador +
                '&carregarLimit=' +
                valorLimite +
                '&cd_pav_cliente_not=true'
            )
          }
          inserirData(data.data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, renderizar, filtros])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData
    if (controladorPagina <= paginaAtual) {
      if (controladorPagina <= paginaAtual && filtros.vazio) {
        if (isTelaPortalCliente()) {
          apiData = await api_gateway.get(
            '/m1/consultar/cliente?contar=true&buscar=' +
              conteudoBusca +
              '&cd_pav_cliente_not=true&telaClientePortal=true&separadorLinha=' +
              separadorLinha
          )
        } else {
          apiData = await api_gateway.get(
            '/m1/consultar/cliente?contar=true&buscar=' +
              conteudoBusca +
              '&cd_pav_cliente_not=true&separadorLinha=' +
              separadorLinha
          )
        }
      } else {
        const dados = {
          paginaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros,
          contar: true,
          cd_pav_cliente_not: true
        }
        if (isTelaPortalCliente()) {
          dados.filtros.n0_cliente_nivel = 3
        }
        apiData = await api_gateway.post('/m1/filtrar/cliente', dados)
      }
      itensVar = []
      if (apiData.data.dados) {
        totalItens = apiData.data.dados[0].CONTADOR
        totalPaginas = Math.ceil(totalItens / valorLimite)
        for (var i = 0; i < totalItens; i++) {
          arrayItens.push(i)
        }
        itensVar = arrayItens
      }
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  const formatter = (cell) => {
    return <LabelTabela>{cell || '-'}</LabelTabela>
  }

  const colunas = [
    {
      dataField: 'cd_pav_cliente',
      text: 'ID',
      sort: true,
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      headerStyle: () => {
        return { width: '130px' }
      },
      formatter
    },
    {
      dataField: 'cd_pav_pessoa',
      headerClasses: 'nao-selecionavel',
      text: 'ID pessoa',
      hidden: true,
      formatter
    },
    {
      dataField: 'cd_pav_tipo_pessoa',
      headerClasses: 'nao-selecionavel',
      text: 'ID tipo pessoa',
      hidden: true,
      formatter
    },
    {
      dataField: 'ds_pav_tipo_pessoa',
      headerClasses: 'nao-selecionavel',
      text: 'Tipo pessoa',
      sort: true,
      formatter
    },
    {
      dataField: 'ds_cnpj',
      headerClasses: 'nao-selecionavel',
      text: 'CNPJ',
      sort: true,
      formatter
    },
    {
      dataField: 'ds_pav_cliente',
      headerClasses: 'nao-selecionavel',
      text: 'Razão social',
      sort: true,
      formatter: (cell, row) => {
        let valor = cell === 'undefined' || !cell ? '-' : cell
        if (!row?.cd_pav_tipo_pessoa) {
          return '-'
        } else {
          const pessoaJuridica = row?.cd_pav_tipo_pessoa == 2
          if (valor && !pessoaJuridica) valor = '-'

          return <LabelTabela>{valor}</LabelTabela>
        }
      }
    },
    {
      dataField: 'ds_nome_fantasia',
      headerClasses: 'nao-selecionavel',
      text: 'Nome fantasia',
      sort: true,
      formatter
    },
    {
      dataField: 'ds_nome',
      headerClasses: 'nao-selecionavel',
      text: 'Nome',
      sort: true,
      formatter: (cell, row) => {
        let valor = cell || '-'

        const pessoaJuridica = row?.cd_pav_tipo_pessoa == 2
        if (!row?.cd_pav_tipo_pessoa || (cell && pessoaJuridica)) return '-'

        return <LabelTabela>{valor}</LabelTabela>
      }
    },
    {
      dataField: 'ds_email',
      headerClasses: 'nao-selecionavel',
      text: 'E-mail',
      sort: true,
      formatter
    },
    {
      dataField: 'ds_telefone',
      headerClasses: 'nao-selecionavel',
      text: 'Telefone',
      sort: true,
      formatter: (cell) => {
        const valor = cell?.trim() || '-'
        return <LabelTabela>{valor}</LabelTabela>
      }
    },
    {
      dataField: 'n0_nivel',
      headerClasses: 'nao-selecionavel',
      text: 'Nível Cliente',
      sort: true,
      formatter
    }
  ]

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setItensSelecionados(row)
      despacho(desabilitarAcoes(false))
    }
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }
  async function handleMensagemAtencao(confirmacao) {
    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
      if (confirmacao === true) {
        ColetaClickstream(1438) // dropAcoesRevelarCadastroClienteExcluirConfirmar
        await api_gateway
          .get(
            '/m1/deletar/cliente?cd_pav_cliente=' +
              itensSelecionados.cd_pav_cliente
          )
          .then((response) => {
            if (response.data.status == 200) {
              setMensagemSucesso(
                'O cliente ' +
                  itensSelecionados.ds_nome_fantasia +
                  ' foi deletado com sucesso'
              )
              setRevelarMensagemSucesso(true)
            } else {
              setRevelarMensagemErro(true)
            }
          })
          .catch(() => {
            setRevelarMensagemErro(true)
          })
      } else {
        ColetaClickstream(1437) // dropAcoesRevelarCadastroClienteExcluirCancelar
      }
    }
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      if (confirmacao === true) {
        //ALGUMA FUNÇÃO
        setRenderizar(!renderizar)
        window.location.reload()
      } else {
        window.location.reload()
      }
    }
  }

  const renderDetalhamentoLinha = (row) => {
    return (
      <DetalhamentoCliente
        noCdCliente={row.n0_codigo_cliente}
        cdTipoCliente={row.cd_cliente_tipo}
        cdCliente={row.cd_pav_cliente}
        logradourocliente={row.logradouro}
        bairrocliente={row.bairro}
        ufcliente={row.uf}
        cidadecliente={row.cidade}
        cepcliente={row.cep}
        vendedorcliente={row.ds_nome}
        cpfVendedorCliente={row?.ds_cpf}
        emailVendedorCliente={row.ds_email}
        telefoneVendedorCliente={row.ds_telefone}
      />
    )
  }

  function transformarObjeto(dados) {
    let novoObjeto = []

    dados.forEach((item) => {
      let novoItem = {
        id: item.cd_cliente_tipo,
        label: item.ds_nome
      }
      novoObjeto.push(novoItem)
    })

    return novoObjeto
  }

  function getTipoCliente(clienteTipo) {
    let cliente = tipoCliente.filter((cliente) => cliente.id == clienteTipo)[0]
    return cliente
  }

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const itensSelecionadosTable = itensSelecionados?.[TableprimaryKey]
    ? [itensSelecionados[TableprimaryKey]]
    : []

  return (
    <>
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        spinAtivo={spinAtivo}
        revelarBarraFiltro={revelarBarraFiltro}
        permissaoDetalhamentoLinha={!clientePortal}
        detalhamentLinha={renderDetalhamentoLinha}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados: itensSelecionadosTable,
          modeSelection: 'radio',
          handleOnSelect
        }}
      />
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {revelarImportarClientesUsuarios === true && (
        <>
          <div className="componente-modal-overlay">
            <div className="componente-modal">
              <ImportarClientesUsuarios
                setRenderizar={setRenderizar}
                renderizar={renderizar}
                telaOrigem={
                  isTelaMeusClientes() ? 'meusClientes' : 'cadastroCliente'
                }
              />
            </div>
          </div>
        </>
      )}
      {NovoCliente === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroCliente
              tituloJanela="Cadastrar"
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              isN3={isTelaMeusClientes()}
            />
          </div>
        </div>
      )}
      {EditarCliente === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroCliente
              tituloJanela="Editar"
              cdCliente={itensSelecionados?.cd_pav_cliente}
              tipoCliente={getTipoCliente(itensSelecionados?.cd_cliente_tipo)}
              dsCliente={itensSelecionados?.ds_pav_cliente}
              dsCpf={itensSelecionados?.ds_cpf}
              dsCnpj={itensSelecionados?.ds_cnpj}
              cdPessoa={itensSelecionados?.cd_pav_pessoa}
              dsNomeFantasia={itensSelecionados?.ds_nome_fantasia}
              dsEmail={itensSelecionados?.ds_email}
              dsTelefone={itensSelecionados?.ds_telefone}
              dsTipoPessoa={itensSelecionados?.ds_pav_tipo_pessoa}
              cdTipoPessoa={itensSelecionados?.cd_pav_tipo_pessoa}
              renderizar={renderizar}
              row={itensSelecionados}
              setRenderizar={setRenderizar}
              isN3={isTelaMeusClientes()}
            />
          </div>
        </div>
      )}

      {revelarMensagemSucesso && (
        <RenderMensagemSucesso
          handleMensagemSucesso={handleMensagemSucesso}
          mensagemTitulo="Sucesso"
          mensagemParagrafo1={mensagemSucesso}
          mensagemBotao="Continuar"
        />
      )}
      {revelarMensagemErro && (
        <RenderMensagemErro
          handleMensagemErro={handleMensagemErro}
          mensagemTitulo={mensagemErro}
          mensagemParagrafo1="Erro"
          mensagemParagrafo2={mensagemErro}
          mensagemBotao="Retornar"
        />
      )}
      {revelarMensagemAtencao && (
        <RenderMensagemAtencao
          handleMensagemAtencao={handleMensagemAtencao}
          mensagemTitulo="Deseja remover cliente?"
          mensagemBotao="Remover"
        />
      )}
    </>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}

export default connect(mapStateToProps)(React.memo(Clientes))
